// extracted by mini-css-extract-plugin
export default {"news_d":"News_news_d__Felca","news_l":"News_news_l__YI+q-"};